import React from 'react';
import { GoogleMap, LoadScript, Marker, useJsApiLoader } from '@react-google-maps/api';
import { useQuery } from 'react-query';
import useStore from '../../../Store/Store';
import { getLocation, getUserLocation } from '../../../utils/api';
import { isEmpty } from 'lodash';

// Google Maps container styles
const mapContainerStyle = {
  width: '100%',
  height: '100%',
};

// Initial center of the map
const center = {
  lat: 40.6974881,
  lng: -73.979681,
};

const MapCard = () => {
  const selectedRecipient = useStore((state) => state.selectedRecipient);
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);

  const [map, setMap] = React.useState(null);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });
  const onLoad = React.useCallback(function callback(map) {
    map.setZoom(12);
    map.setCenter(center);
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const { data, isLoading } = useQuery(
    ['getLocation', 'getUserLocation', selectedRecipient],
    () => {
      if (isEmpty(selectedRecipient)) {
        return getLocation({ userId: user?._id || user?.id });
      } else {
        return getUserLocation({ userId: user?._id || user?.id, recipientId: selectedRecipient });
      }
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 30000,
    },
  );

  return (
    <div className="tasks top-margin-card" style={{ padding: 0, marginLeft: width > 550 ? '20px' : '0px' }}>
      {isLoaded ? (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={{
            lat: data?.data?.coordinates?.lat,
            lng: data?.data?.coordinates?.lng,
          }}
          zoom={12}
          onLoad={onLoad}
          onUnmount={onUnmount}
          options={{
            disableDefaultUI: true,
            zoomControl: false,
          }}
        >
          {!isEmpty(data?.data) && (
            <Marker
              position={{
                lat: data?.data?.coordinates?.lat || center.lat,
                lng: data?.data?.coordinates?.lng || center.lng,
              }}
            />
          )}
        </GoogleMap>
      ) : (
        'loading...'
      )}
    </div>
  );
};

export default MapCard;
